import { AuditPage } from "@/pages/platform/PlatformAudit";
import { useSpaceName } from "@/context/AuthContext";

export default function SchoolAudit() {
  const space = useSpaceName();
  return <AuditPage url="/school/audit" queryKey="school-audit" eyebrow={space}
    description="Catatan audit khusus sekolah ini. Catatan bersifat tambah-saja dan tidak dapat dihapus." />;
}
